export const SET_ADVANCE_RULE_ENGINE_FORM_REDUX = 'SET_ADVANCE_RULE_ENGINE_FORM_REDUX';
export const CLEAR_ADVANCE_RULE_ENGINE_FORM_REDUX = 'CLEAR_ADVANCE_RULE_ENGINE_FORM_REDUX';


export const FETCH_ADVANCE_RULE_ENGINE_RULE_LIST = 'FETCH_ADVANCE_RULE_ENGINE_RULE_LIST';
export const SET_ADVANCE_RULE_ENGINE_RULE_LIST_TABLE_PROPS = 'SET_ADVANCE_RULE_ENGINE_RULE_LIST_TABLE_PROPS';
export const SET_ADVANCE_RULE_ENGINE_RULE_LIST_REQUEST_HASH = 'SET_ADVANCE_RULE_ENGINE_RULE_LIST_REQUEST_HASH';
export const SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER = 'SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER';


export const FETCH_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY = 'FETCH_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY';
export const SET_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY_TABLE_PROPS = 'SET_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY_TABLE_PROPS';
export const SET_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY_REQUEST_HASH = 'SET_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY_REQUEST_HASH';

export const SET_DERIVED_CONDITION_FORM_REDUX = 'SET_DERIVED_CONDITION_FORM_REDUX';
export const CLEAR_DERIVED_CONDITION_FORM_REDUX = 'CLEAR_DERIVED_CONDITION_FORM_REDUX';

export const FETCH_DERIVED_CONDITIONS_LIST = 'FETCH_DERIVED_CONDITIONS_LIST';
export const SET_DERIVED_CONDITIONS_LIST_TABLE_PROPS = 'SET_DERIVED_CONDITIONS_LIST_TABLE_PROPS';
export const SET_DERIVED_CONDITIONS_LIST_REQUEST_HASH = 'SET_DERIVED_CONDITIONS_LIST_REQUEST_HASH';


export const CLEAR_ADVANCE_RULE_ENGINE_DASHBOARD = 'CLEAR_ADVANCE_RULE_ENGINE_DASHBOARD';


export const FETCH_RULE_EXECUTION_SUMMARY_LIST = 'FETCH_RULE_EXECUTION_SUMMARY_LIST';
export const SET_RULE_EXECUTION_SUMMARY_LIST_TABLE_PROPS = 'SET_RULE_EXECUTION_SUMMARY_LIST_TABLE_PROPS';
export const SET_RULE_EXECUTION_SUMMARY_LIST_REQUEST_HASH = 'SET_RULE_EXECUTION_SUMMARY_LIST_REQUEST_HASH';
export const SET_RULE_EXECUTION_SUMMARY_LOADER = 'SET_RULE_EXECUTION_SUMMARY_LOADER';

export const SET_ADVANCE_RULE_ENGINE_LAYOUT_VIEW = 'SET_ADVANCE_RULE_ENGINE_LAYOUT_VIEW';

export const FETCH_RULE_TRIGGER_LOGS_LIST = 'FETCH_RULE_TRIGGER_LOGS_LIST';
export const SET_RULE_TRIGGER_LOGS_LIST_TABLE_PROPS = 'SET_RULE_TRIGGER_LOGS_LIST_TABLE_PROPS';
export const SET_RULE_TRIGGER_LOGS_LIST_REQUEST_HASH = 'SET_RULE_TRIGGER_LOGS_LIST_REQUEST_HASH';
export const SET_RULE_TRIGGER_LOGS_LOADER = 'SET_RULE_TRIGGER_LOGS_LOADER';